document.addEventListener('change', (event) => {
  const option = event.target.closest('[data-lc-product] input[name="id"]');
  if (!option) return;
  const card = option.closest('[data-lc-product]');
  const image = card.querySelector('[data-lc-image]');
  const color = card.querySelector('[data-lc-color]');
  color.textContent = `Color: ${option.dataset.color} · Loading image…`;
  image.setAttribute('aria-busy', 'true');
  image.hidden = false;
  image.onload = () => {
    image.removeAttribute('aria-busy');
    color.textContent = `Color: ${option.dataset.color}`;
  };
  image.onerror = () => {
    image.removeAttribute('aria-busy');
    image.hidden = true;
    color.textContent = `Color: ${option.dataset.color} · View photo on product page`;
  };
  if (!image.dataset.originalSrc) {
    image.dataset.originalSrc = image.src;
    image.dataset.originalSrcset = image.srcset;
  }
  const isOriginal = option.value === image.dataset.defaultVariant;
  image.srcset = isOriginal ? image.dataset.originalSrcset : '';
  image.src = isOriginal ? image.dataset.originalSrc : option.dataset.image;
  image.alt = option.dataset.title;
  image.classList.toggle('lc-product-image--variant', !isOriginal);
  card.querySelector('[data-lc-price]').textContent = option.dataset.price;
  const available = option.dataset.available === 'true';
  const add = card.querySelector('[data-lc-add]');
  add.disabled = !available;
  add.setAttribute('aria-label', `Add ${option.dataset.title} to bag`);
  card.querySelector('[data-lc-stock]').textContent = available ? '' : 'Sold out';
  card.querySelectorAll('[data-lc-product-link]').forEach((link) => {
    const url = new URL(link.href);
    url.searchParams.set('variant', option.value);
    link.href = url.href;
  });
});

document.addEventListener('pointerover', (event) => {
  const swatch = event.target.closest('.lc-swatch');
  if (!swatch || swatch.contains(event.relatedTarget)) return;
  const option = swatch.querySelector('input');
  if (!option.checked) new Image().src = option.dataset.image;
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.lc-header details[open]').forEach((menu) => {
    menu.removeAttribute('open');
    menu.querySelector('summary').focus();
  });
});

document.addEventListener('click', (event) => {
  document.querySelectorAll('.lc-header details[open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.removeAttribute('open');
  });
});
